import LanguageMixin from '../lang'
import SettingsMixin from '../settings'

export default {
  mixins: [LanguageMixin, SettingsMixin],
}

